import React from 'react';
import Stack from '@mui/material/Stack';
import { InfoTypography } from './Seller.style';
import { Section } from '../Section';
export const SellerCertification = ({ certification }) => {
    return (React.createElement(Section, { spacing: 1 },
        React.createElement(Stack, { direction: "row", width: "100%", justifyContent: "space-between" },
            React.createElement(InfoTypography, { "data-qa": "certification-text" }, certification || `Ce vendeur a déclaré certifier s’engager à ne fournir que des produits et services conformes aux règles applicables du droit de
          l’Union et des droits nationaux conformément au certificat d'engagement.`))));
};
